import { createFileRoute } from '@tanstack/react-router';
import { endOfMonth, startOfMonth } from 'date-fns';
import { useState } from 'react';
import AuthGuard from '@/components/auth-guard';
import { CategoryAnalytics } from '@/components/dashboard/category-analytics';
import type { PeriodSelection } from '@/components/dashboard/period-selector';
import { PeriodSelector } from '@/components/dashboard/period-selector';

export const Route = createFileRoute('/categories')({
  component: CategoriesPage,
});

function CategoriesPage() {
  const today = new Date();
  const [selectedPeriod, setSelectedPeriod] = useState<PeriodSelection>({
    type: 'current',
    startDate: startOfMonth(today),
    endDate: endOfMonth(today),
    label: 'Mês atual',
  });

  return (
    <AuthGuard requireAuth={true}>
      <div className="container mx-auto space-y-6 px-4 py-6">
        <div className="flex items-center justify-between gap-4">
          <h1 className="font-bold text-2xl">Análise por Categorias</h1>
          <div className="flex-1">
            <PeriodSelector
              onPeriodChange={setSelectedPeriod}
              selectedPeriod={selectedPeriod}
            />
          </div>
        </div>

        <CategoryAnalytics selectedPeriod={selectedPeriod} />
      </div>
    </AuthGuard>
  );
}
